module.exports = __webpack_public_path__ + "img/progressImg.ee89afd6.svg";